import { Controller } from 'stimulus';
import dataLayer from '../helpers/dataLayer';
import toArray from '../helpers/toArray';

class PricingController extends Controller {
  connect() {
    this.frequency = 'monthly';
  }

  onPaymentFrequenyChange(e) {
    this.frequency = e.target.checked ? 'yearly' : 'monthly';

    dataLayer.event('Pricing unit', 'change', this.frequency);

    this.changeSwitchText();
    this.changePrice();
    this.changeSubtitle();
  }

  changeSwitchText() {
    this.switchTextTargets.forEach((switchText) => {
      const switchTextFrequency = switchText.getAttribute('data-frequency');

      switchText.classList.toggle('is-active', switchTextFrequency === this.frequency);
    });
  }

  changePrice() {
    this.priceTargets.forEach((price) => {
      price.innerText = price.getAttribute(`data-${this.frequency}`);
    });
  }

  changeSubtitle() {
    this.subtitleTargets.forEach((subtitle) => {
      subtitle.innerText = subtitle.getAttribute(`data-${this.frequency}`);
    });
  }

  // eslint-disable-next-line class-methods-use-this
  onButtonClick(event) {
    const { currentTarget } = event;

    if (!currentTarget.getAttribute('data-plan')) {
      return true;
    }

    dataLayer.event('Price overview button', 'click', currentTarget.getAttribute('data-plan'));

    return true;
  }

  // eslint-disable-next-line class-methods-use-this
  onReadMoreClick(event) {
    const group = event.target.closest('.js-read-more-group');

    if (group) {
      const readmoreButtonRow = group.querySelector('.js-read-more-button');
      const isOpen = readmoreButtonRow.classList.contains('is-open');

      // Toggle the items that should be hidden/visible
      toArray(group.querySelectorAll('.js-read-more'))
        .forEach((readmoreRow) => {
          readmoreRow.classList.toggle('d-none', isOpen);
        });

      readmoreButtonRow.classList.toggle('is-open', !isOpen);
    }
  }
}

PricingController.targets = [
  'switchText',
  'price',
  'subtitle',
  'readmoreRow',
];

export default PricingController;
